import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Dropdown } from '../Dropdown/Dropdown';
import { HeaderButtons } from '../HeaderButtons/HeaderButtons';

export const Header = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box width={240}>
        <Dropdown />
      </Box>

      <HeaderButtons />
    </Box>
  );
};
